import {useState} from "react";

export const useModalSearchTicketsDescriptionStatic = () => {

  const [visibleModalDelete, setVisibleModalDelete] = useState<boolean>(false);
  const [visibleModalRestore, setVisibleModalRestore] = useState<boolean>(false);
  const [visibleModalNewTicketsDescriptionStatic, setVisibleModalNewTicketsDescriptionStatic] = useState<boolean>(false);


  return {
    visibleModalDelete,
    setVisibleModalDelete,
    visibleModalRestore,
    setVisibleModalRestore,
    visibleModalNewTicketsDescriptionStatic, setVisibleModalNewTicketsDescriptionStatic,
  }
}
